/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from "@emotion/react";
import React from "react";
import { FilterItem } from "./FilterItem";
import { FilterPopover } from "./FilterPopover";

const filterButtonStyling = css`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 8px; /* Consistent spacing between items */
`;

const FilterItemWrapper = ({ children }: { children: React.ReactNode }) => {
  const styling = css`
    display: inline-block;
    vertical-align: top;
    height: 33px;
  `;

  return <div css={styling}>{children}</div>;
};

type Props = {
  chosenFilters: {
    label: string;
    chosenValues: string[];
    onChangeValues: (values: string[]) => void;
    removeFilter: () => void;
    options: {
      value: string;
      label: string;
    }[];
    singleSelect?: boolean;
  }[];
  newFilterOptions: {
    label?: string;
    name: string;
    icon: React.ReactNode;
    options: {
      value: string;
      label?: string;
    }[];
    singleSelect?: boolean;
  }[];
  onCreateNewFilter: (
    filters: {
      name: string;
      choices: string[];
    }[]
  ) => void;
  additionalStyling?: SerializedStyles;
};
/* 
  This component is used to display the chosen filters and the new filter options.
  It is supposed to be used in List components, like ProductsList.tsx.
*/
export const ListFilterComponent = ({
  chosenFilters,
  newFilterOptions,
  onCreateNewFilter,
  additionalStyling,
}: Props) => {
  return (
    <div css={[filterButtonStyling, additionalStyling]}>
      {chosenFilters
        .filter((cf) => cf.chosenValues && cf.chosenValues.length > 0)
        .map((cf, index) => (
          <FilterItemWrapper key={index}>
            <FilterItem
              label={cf.label}
              values={cf.chosenValues}
              onChange={(values) => {
                cf.onChangeValues(values);
              }}
              removeFilter={() => {
                cf.removeFilter();
              }}
              options={cf.options}
              singleSelect={cf.singleSelect}
            />
          </FilterItemWrapper>
        ))}
      <FilterItemWrapper>
        <FilterPopover
          onCreateFilter={onCreateNewFilter}
          panelAnchor="bottom start"
          filterOptions={newFilterOptions}
        />
      </FilterItemWrapper>
    </div>
  );
};
